import React, { forwardRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// import {useSelector} from "react-redux";
// import {getDefaultOptions} from "@modules/systemSetting/systemModule/helper";
import { DEFALUT_PERMISSION_SECTION } from '@model';
import SubModuleSorter from '@components/subModuleSorter/SubModuleSorter';

const SectionListEdit = forwardRef((props, ref) => {
  const { value, formInstance } = props;
  const cellObj = formInstance?.getFieldValue?.([
    props.rowName,
    props.rowIndex,
  ]);
  const { value: sectionKey, module } = cellObj;

  // const isCustomizePermission = type !== 'default';
  const location = useLocation();
  // const companyInstance = useSelector(
  //   (state) => state.common.projectCompanyInfo.instanceType,
  // );
  // const settingCompanyInstance = useSelector(
  //   (state) => state.common.settingCompanyInstance,
  // );
  // const onProjectSetting = location?.pathname.includes('projects/setting');
  const onSystemSetting = location.pathname?.includes('/settings/systemModule');
  // const projectType = onProjectSetting
  //   ? companyInstance
  //   : settingCompanyInstance;
  // const defaultOptions = useMemo(() => {
  //   return getDefaultOptions({
  //     key: v,
  //     moduleName: module,
  //     location,
  //     isCustomizePermission,
  //     originInternalPermissions
  //   });
  // }, [v, isCustomizePermission, originInternalPermissions]);
  const showSubmoduleSorter =
    !onSystemSetting &&
    [
      DEFALUT_PERMISSION_SECTION.INSIGHT,
      DEFALUT_PERMISSION_SECTION.ANALYSIS,
    ].includes(sectionKey);

  const onChange = (options) => {
    props.onChange([...options]);
  };

  return (
    <div className="mainSection-group">
      {showSubmoduleSorter ? (
        <SubModuleSorter onChange={onChange} options={value || []} />
      ) : (
        <span className="mainSection-span">{module}</span>
      )}
    </div>
  );
});

export default SectionListEdit;
